import { takeLatest, call, put, all } from "redux-saga/effects";
import axios from "axios";
import {
  watcherSaveCustomer,
  watcherUpdateCustomer,
  watcherAddAddress,
  watcherAddOrder,
  watcherRemoveAddress,
  watcherFindAllCustomers,
  watcherSaveAllCustomers,
} from "./workers/customerWorkers";
import {
  watcherFindAllDrivers,
  watcherSaveDriver,
  watcherRemoveDriver,
  watcherUpdateDriver,
  watcherSaveAllDrivers,
} from "./workers/driverWorker";
import {
  watcherFindAllServices,
  watcherSaveService,
  watcherRemoveService,
  watcherSaveAllServices,
} from "./workers/serviceWorker";

import {
  API_SEND_SMS_REQUEST,
  API_SEND_SMS_FAILURE,
  API_SEND_SMS_SUCCESS,
} from "../constants/actions-types";
const apiKey =
  "4D676F33677266674C5234365A7038647667505343437636633967436E514F4E";
export function* rootWatcher() {
  yield all([
    watcherDemoDog(),
    watcherSendSMS(),
    watcherFindAllCustomers(),
    watcherSaveCustomer(),
    watcherUpdateCustomer(),
    watcherSaveAllCustomers(),
    watcherAddAddress(),
    watcherAddOrder(),
    watcherRemoveAddress(),
    watcherUpdateDriver(),
    watcherFindAllDrivers(),
    watcherSaveAllDrivers(),
    watcherSaveDriver(),
    watcherRemoveDriver(),
    watcherSaveService(),
    watcherRemoveService(),
    watcherFindAllServices(),
    watcherSaveAllServices(),
    // watcherSendDriverSMS(),
    // watcherSendCustomerSMS(),
  ]);
}

// watcher saga: watches for actions dispatched to the store, starts worker saga
function* watcherDemoDog() {
  yield takeLatest("API_CALL_REQUEST", workerDemoDog);
}

function* watcherSendSMS() {
  yield takeLatest(API_SEND_SMS_REQUEST, workerSendSMS);
}

// function that makes the api request and returns a Promise for response
function fetchDog() {
  return axios({
    method: "get",
    url: "https://dog.ceo/api/breeds/image/random",
  });
}

function sendSMS(payload) {
  payload.name = payload.name.split(" ").join(" ");

  let url = `https://api.kavenegar.com/v1/${apiKey}/verify/lookup.json?receptor=${payload.phone}&token=${payload.name}&token2=${payload.invoice_number}&template=customer`;
  console.log(url);
  return axios({
    method: "get",
    url: url,
  });
}

function* workerSendSMS(action) {
  try {
    console.log("workerSendSMS", action);
    const response = yield call(sendSMS, action.payload);
    const res = response.data;
    yield put({ type: API_SEND_SMS_SUCCESS, response: res });
  } catch (exception) {
    yield put({ type: API_SEND_SMS_FAILURE, error: exception });
  }
}

// worker saga: makes the api call when watcher saga sees the action
function* workerDemoDog() {
  try {
    const response = yield call(fetchDog);
    const responseDog = response.data.message;
    // dispatch a success action to the store with the new dog
    yield put({ type: "API_CALL_SUCCESS", response: responseDog });
  } catch (error) {
    // dispatch a failure action to the store with the error
    yield put({ type: "API_CALL_FAILURE", error });
  }
}
